<template>
  <div class="w-100">
    <v-container>
      <v-row v-if="categoryHeading">
        <v-col cols="12">
          <h1>
            Arter i
            <GeoSelect
              ><span class="select-geo">{{
                $_currentGeoSection
              }}</span></GeoSelect
            >
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <!-- <v-row class="flex justify-center ma-0 mt-5">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
            <v-text-field
              v-model="search"
              label="Vad letar du efter?"
              solo
              filled
              @keydown="sendSearch"
            >
              <template v-slot:append-outer>
                <div style="transform: translateY(-12px);">
                  <v-btn color="primary" fab dark @click="sendSearch">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-text-field>
          </v-col>
        </v-row> -->
        <v-col cols="12" class="mt-4">
          <CategoriesButtons :categories="categories" />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="s in species"
          :key="s.id"
          :cols="$_colsWidth"
          class="d-flex child-flex"
        >
          <SpeciesCard class="" :species="s" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CategoriesButtons from '@/components/CategoriesButtons.vue'
import SpeciesCard from '@/components/SpeciesCard.vue'
import GeoSelect from '@/components/GeoSelect.vue'
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'
import GeoStuff from '@/mixins/GeoStuff.js'
export default {
  name: 'Species',
  mixins: [Setup, Misc, GeoStuff],
  components: {
    CategoriesButtons,
    SpeciesCard,
    GeoSelect
  },
  data() {
    return {
      showSubCategories: false,
      categoryHeading: 'Arter in Sverige',
      categoryDesc: null,
      slice: { start: 0, end: 20 },
      search: ''
    }
  },
  updated() {
    // We use this for increased performance on first load.
    // When everything is rendered then increase upper end to 1000, eg the rest
    this.slice.end = 1000
  },
  watch: {
    $route(to, from) {
      if (this.setup) this.setup()
    }
  },
  computed: {
    categories() {
      return this.$store.state.categories
    },
    species() {
      return this.$store.getters.getAllSpecies.slice(
        this.slice.start,
        this.slice.end
      )
    }
  },
  methods: {
    sendSearch(e) {
      if (e.type === 'keydown') {
        if (e.key === 'Enter') {
          this.$router.push({ name: 'Search', query: { q: this.search } })
        }
      } else {
        this.$router.push({ name: 'Search', query: { q: this.search } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-geo {
  color: rgba(33, 162, 97, 1);
  text-decoration: underline;
}
</style>
